import React, { useState } from "react";
import styled from "@emotion/styled";
import { useParams, useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  Divider as MuiDivider,
  Grid,
  Typography,
  Paper,
} from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import EditIcon from "@mui/icons-material/Edit";
import { spacing } from "@mui/system";

const Divider = styled(MuiDivider)(spacing);

function LandingPage() {
  const { id: eventId } = useParams();
  const navigate = useNavigate();
  const [publicUrl, setPublicUrl] = useState("");

  const handleCustomizeClick = () => {
    navigate(`/landing-page-builder/${eventId}`);
  };

  const handlePreviewClick = () => {
    // If we have a publicUrl, open it, otherwise open the builder
    if (publicUrl) {
      window.open(`/events/preview/${publicUrl}`, "_blank");
    } else {
      handleCustomizeClick();
    }
  };

  return (
    <React.Fragment>
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Landing Page
          </Typography>
          <Typography>
            Customize your landing page for a unique experience
          </Typography>
        </Grid>
        <Grid item>
          <div>
            <Button
              variant="outlined"
              color="primary"
              onClick={handlePreviewClick}
              style={{ marginRight: "1rem" }}
              startIcon={<PreviewIcon />}
            >
              Preview
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCustomizeClick}
              startIcon={<EditIcon />}
            >
              Customize
            </Button>
          </div>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Box style={{ marginTop: "15px", marginBottom: "15px" }}>
        <Paper sx={{ p: 3, textAlign: "center" }}>
          <img
            src="/static/img/others/BrandingLandingPage.png"
            alt="Landing Page Template"
            style={{
              maxWidth: "100%",
              height: "auto",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            }}
          />

          <Typography variant="h5" sx={{ mt: 3, mb: 1 }}>
            Create Your Event Landing Page
          </Typography>

          <Typography
            variant="body1"
            sx={{ mb: 3, maxWidth: "800px", mx: "auto" }}
          >
            Customize your event landing page with sections like header banner,
            about, speakers, agenda, and sponsors. Drag and drop to rearrange,
            edit content to personalize, and share with attendees using a public
            URL.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleCustomizeClick}
            startIcon={<EditIcon />}
          >
            Start Customizing
          </Button>
        </Paper>
      </Box>
    </React.Fragment>
  );
}

export default LandingPage;
